import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import ListView from '../../../base/ListView';
import { toImmutable } from '../../../libs/immutable-transformer';
import { ajaxErrorHandler, defaultError } from '../../../libs/utils';
import { getCrewMembers } from '../../../services/api/crewMembers';
import { getParkingRequests } from '../../../services/api/registrationParkings';
import { getRegistrations } from '../../../services/api/registrations';
import CustomTypeahead from '../../forms/fields/CustomTypeahead';
import { FormikPropTypes } from '../../forms/helpers/formikPropTypes';
import CompanySelector from '../../forms/reusable/companySelector';

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      crewmembers: [],
      registrationId: undefined,
      vouchers: [],
      vouchersMeta: {},
    };

    this._handleCrewMemberSearch = this._handleCrewMemberSearch.bind(this);
    this._handleNewCrewMember = this._handleNewCrewMember.bind(this);
    this._loadVouchers = this._loadVouchers.bind(this);
    this._load = this._load.bind(this);
  }

  static propTypes = {
    event: PropTypes.object,
    ...FormikPropTypes,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.values.companyId !== nextProps.values.companyId && nextProps.values.companyId) {
      getRegistrations({
        'filter[event_id]': this.props.event.id,
        'filter[company_id]': nextProps.values.companyId,
      }).then((response) => {
        if (response.data.length > 0) {
          this.setState({
            registrationId: response.data[0].id,
          });
        } else {
          defaultError('This company is not working on ' + this.props.event.name);
          this.props.setFieldValue('companyId', '');
        }
      });
    }

    if (this.props.values.companyId !== nextProps.values.companyId && !nextProps.values.companyId) {
      this.setState({
        registrationId: undefined,
      });
    }

    if (
      this.props.activeVoucher !== nextProps.activeVoucher &&
      !nextProps.activeVoucher &&
      this.state.latestCrewMember
    ) {
      this._loadVouchers(this.state.latestCrewMember);
    }
  }

  _handleCrewMemberSearch(value) {
    getCrewMembers({
      'filter[registration_id]': this.state.registrationId,
      'filter[name_like]': value,
      'include': 'user',
    }).then((response) => {
      this.setState({
        crewmembers: response.data,
      });
    });
  }

  _handleNewCrewMember(values) {
    if (values.length > 0) {
      this.props.setFieldValue('crewMemberId', values[0].id);
      this.setState({
        latestCrewMember: values[0],
      });
      this._loadVouchers(values[0]);
    } else {
      this.props.setFieldValue('crewMemberId', '');
    }
  }

  _load(filters) {
    this._loadVouchers(this.state.latestCrewMember, filters);
  }

  _loadVouchers(crewMember, extraFilters = {}) {
    this.setState({
      loading: true,
    });

    getParkingRequests(this.state.registrationId, {
      'page[number]': 1,
      'page[size]': 1000,
      'filter[crew_member_id]': crewMember.id,
      'sort': '-updated_at',
      'include':
        'parking,crew-member,crew-member.user,parking-request-parking-stickers,parking-request-parking-stickers.parking-sticker',
    })
      .then((response) => {
        let stickers = [];
        for (let i = 0; i < response.data.length; i++) {
          const newStickers = [...response.data[i].parkingRequestParkingStickers];
          for (let j = 0; j < newStickers.length; j++) {
            newStickers[j].crewMember = response.data[i].crewMember;
            newStickers[j].parking = response.data[i].parking;
          }

          stickers = stickers.concat(newStickers);
        }

        response.meta.to = stickers.length;
        response.meta.total = stickers.length;

        this.setState({
          vouchers: stickers,
          vouchersMeta: response.meta,
          loading: false,
        });
      })
      .catch(ajaxErrorHandler);
  }

  render() {
    const props = this.props;
    const { crewmembers, latestCrewMember } = this.state;

    const { vouchers, vouchersMeta } = this.state;

    const listViewConf = {
      dataSet: vouchers,
      dataMeta: vouchersMeta,
      columns: [
        {
          key: 'parking.name',
          value: 'Parking',
        },
        {
          key: 'parkingSticker.name',
          value: 'Sticker',
        },
        {
          key: 'claimedAt',
          value: 'Redeemed',
        },
      ],
      filters: [],
      baseFilters: toImmutable({}),
      actions: {
        deleteLink: false,
        editLink: false,
        detailsLink: false,

        deleteFunction: this._handleDelete,
        customLink: (item) => (
          <span>
            {!item.claimedAt && (
              <button
                className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5"
                onClick={() => this.props.setActiveVoucher(item)}
              >
                <span>
                  <i className="la la-print" />
                  <span>Hand Out</span>
                </span>
              </button>
            )}
          </span>
        ),
      },
      url: '',
    };

    return (
      <form className="m-form" onSubmit={props.handleSubmit}>
        <div className="m-portlet__body">
          <input type="hidden" name="id" />

          <CompanySelector {...props} name="companyId" />

          {props.values.companyId && (
            <CustomTypeahead
              name="crewMemberId"
              label="Crew Member"
              multiple={false}
              options={crewmembers}
              placeholder="Choose a company"
              labelKey={(item) => item.user.firstName + ' ' + item.user.lastName}
              onSearch={this._handleCrewMemberSearch}
              onChange={this._handleNewCrewMember}
              {...this.props}
            />
          )}

          {props.values.crewMemberId && (
            <div>
              <div className="row">
                <div className="col-xl-12 m--align-right">
                  <button
                    type="button"
                    className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                    onClick={this._generate}
                  >
                    <span>
                      <i className="la la-file-pdf-o" />
                      <span>Re-Generate</span>
                    </span>
                  </button>
                  <button
                    type="button"
                    className="m-portlet__nav-link btn btn-outline-warning m-btn m-btn--icon m--margin-left-10"
                    onClick={() => this.props.startManualHandout(latestCrewMember)}
                  >
                    <span>
                      <i className="la la-warning" />
                      <span>Manual Handout</span>
                    </span>
                  </button>
                </div>
              </div>
              <ListView config={listViewConf} handleFilterUpdate={this._load} />
            </div>
          )}
        </div>
      </form>
    );
  }
}

const ParkingStickersVouchersSearchForm = withFormik({
  mapPropsToValues: (props) => {
    let values = {
      companyId: '',
    };

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.barcode || values.barcode === '') {
      errors.barcode = 'required';
    }

    return errors;
  },

  handleSubmit: (values, { props, resetForm }) => {
    props
      .onSubmit(values)
      .then()
      .catch()
      .then((reponse) => {
        resetForm();
        document.querySelector('input[name=barcode]').focus();
      });
  },
})(InnerForm);

export default ParkingStickersVouchersSearchForm;
